import React, { useState, useEffect } from 'react';
import { Radio, Grid, CircularProgress } from '@mui/material';
import { withStyles } from '@mui/styles';
import useStyles from '../useStyles';
import PropTypes from 'prop-types';
import axios from 'axios';

const PinkRadio = withStyles({
  root: {
    '&$checked': {
      color: '#E60278'
    }
  },
  checked: {}
})((props) => <Radio color="default" {...props} />);

function AdProductSelection({
  debouncedTitle,
  answers,
  setAnswers,
  requiredRefs,
  jobAdId,
  setMaxBulletPoints,
  setBrandingEnabled
}) {
  const [seekAdProduct, setSeekAdProduct] = useState(null);
  const [adProductInfo, setAdProductInfo] = useState('');
  const [loadingSeekAdProduct, setLoadingSeekAdProduct] = useState(true);
  const [selectedId, setSelectedId] = useState(null);
  const classes = useStyles();

  const setSelectedValue = (value) => {
    setSelectedId(value);
    setAnswers({ ...answers, ad_type: value });
  };

  const handleChangeAdType = (ad) => {
    setSelectedValue(ad.id.value);
    setBrandingEnabled(!!ad.features.branding);
    setMaxBulletPoints(
      ad.features.searchBulletPoints ? Number(ad.features.searchBulletPoints.limit) : 0
    );
  };

  useEffect(() => {
    const getSeekAdProducts = async (url) => {
      setLoadingSeekAdProduct(true);
      try {
        const { data } = await axios.get(url, {
          params: {
            listing_sub_classification: answers.listing_sub_classification,
            listing_location: answers.listing_location,
            title: debouncedTitle,
            job_ad_id: jobAdId
          }
        });
        const { products, information } = data.data.advertisementProducts;
        setSeekAdProduct(products);
        setAdProductInfo(information);

        products.forEach((product) => {
          if (product.selected) {
            handleChangeAdType(product);
          }
        });
      } catch (exception) {
        console.error(exception);
        setSeekAdProduct(null);
      } finally {
        setLoadingSeekAdProduct(false);
      }
    };

    answers.listing_sub_classification &&
      debouncedTitle &&
      answers.listing_location &&
      getSeekAdProducts(`/api/v4/seek/job_ads/${jobAdId}/ad_products`);
  }, [answers.listing_location, answers.listing_sub_classification, debouncedTitle, jobAdId]);

  if (loadingSeekAdProduct) {
    return <CircularProgress size={20} color="inherit" />;
  }

  return (
    <Grid container>
      {seekAdProduct &&
        seekAdProduct.map((ad, index) => {
          const id = ad.id.value;
          const selected = selectedId === id;
          return (
            <Grid item xs={12} sm={12} md={Math.floor(12 / seekAdProduct.length)} key={index}>
              <div className={classes.seekAdType} onClick={() => handleChangeAdType(ad)}>
                <div
                  className="seekAdheaderWrapper"
                  style={
                    index === 0 || index === seekAdProduct.length - 1
                      ? { borderRadius: index === 0 ? '5px 0 0 0' : '0 5px 0 0' }
                      : {}
                  }
                >
                  Pay using your SEEK Contract
                </div>
                <div
                  style={
                    selected
                      ? { border: '#E60278 1px solid', height: 'calc(100% - 2rem)' }
                      : { border: '#E9E8E8 1px solid', height: 'calc(100% - 2rem)' }
                  }
                >
                  <div className="seekRadioRadioBtnWrapper" ref={requiredRefs.ad_type}>
                    <PinkRadio
                      checked={selected}
                      onChange={() => handleChangeAdType(ad)}
                      value={id}
                      name="radio-buttons"
                      inputProps={{ 'aria-label': 'A' }}
                    />
                  </div>
                  <h4>{ad.label}</h4>
                  <div>{ad.price && ad.price.summary}</div>
                  <div className={classes.seekEmbeddedHTML}>
                    <div>{ad.description}</div>
                    <ul>
                      {ad.sellingPoints.map((sp, index) => (
                        <li key={index}>{sp.text}</li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
            </Grid>
          );
        })}
      <p className={classes.adProductInfo}>{adProductInfo}</p>
    </Grid>
  );
}

AdProductSelection.propTypes = {
  answers: PropTypes.object.isRequired,
  setAnswers: PropTypes.func.isRequired,
  requiredRefs: PropTypes.object.isRequired,
  jobAdId: PropTypes.number,
  setMaxBulletPoints: PropTypes.func.isRequired,
  setBrandingEnabled: PropTypes.func.isRequired,
  debouncedTitle: PropTypes.string
};

export default AdProductSelection;
